<template>
    <v-dialog persistent v-model="dialogOpen" max-width="900">
        <v-card class="pa-3" v-if="student">
            <div v-if="!student.name" class="pa-3">
                <v-card-title class="pl-0">New Student</v-card-title>
                <v-flex xs5>
                    <v-select
                        hide-details
                        :items="newStudents"
                        label="New Student"
                        ref="newStudent"
                        v-model="newStudent"
                        :rules="[]"
                        box
                        item-text="`${data.item.engName} - ${data.item.hebName} (${data.item.class})` "
                    >
                        <template slot="selection" slot-scope="data">
                            {{ data.item.engName }} -
                            {{ data.item.hebName }}
                        </template>
                        <template slot="item" slot-scope="data">
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="
                                        `${data.item.engName} - ${
                                            data.item.hebName
                                        }`
                                    "
                                >
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </v-select>
                </v-flex>
            </div>
            <div v-if="student.name">
                <v-layout row justify-space-between>
                    <v-card-title
                        >{{ student.name }}
                        -
                        {{ student.hebName }}
                        ({{ student.class }})</v-card-title
                    >
                    <v-card-actions>
                        <v-btn
                            class="text-xs-right"
                            small
                            color="success"
                            @click="resetPrice"
                            >Reset Price</v-btn
                        >
                    </v-card-actions>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="pa-3">
                    <v-radio-group
                        v-model="student.enrollment.regType"
                        row
                        @change="updateTotal(student, true)"
                        hide-details
                    >
                        <v-radio
                            class="py-2"
                            label="Full"
                            value="FULL"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="First Half"
                            value="HALF 1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="Second Half"
                            value="HALF 2"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="Custom"
                            value="CUSTOM"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="None"
                            value="NONE"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </v-layout>
                <v-layout
                    class="pa-3 mt-2"
                    row
                    justify-start
                    v-if="student.enrollment.regType == 'CUSTOM'"
                >
                    <v-checkbox
                        @change="updateTotal(student, true)"
                        class="ma-0 pa-0 weeks-selection"
                        v-for="(week, index) in dates.map((d) => d.parshe)"
                        :key="week"
                        :label="`${index + 1} ${week}`"
                        color="success"
                        v-model="student.enrollment[getWeekProperty(index)]"
                    ></v-checkbox>
                </v-layout>
                <v-layout row class="pa-3 mt-2">
                    <v-flex xs4>
                        <v-select
                            hide-details
                            :items="classes"
                            label="Class"
                            ref="chosenClass"
                            v-model="student.chosenClass"
                            :rules="[
                                (value) =>
                                    rules.required(
                                        value,
                                        student.enrollment.regType
                                    ),
                            ]"
                            box
                            item-text="`${data.item.grade} - ${data.item.teacher}`"
                        >
                            <template slot="selection" slot-scope="data">
                                {{ data.item.grade }} -
                                {{ data.item.teacher }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        v-html="
                                            `${data.item.grade} - ${
                                                data.item.teacher
                                            }`
                                        "
                                    >
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs4 class="pl-3 pb-3">
                        <v-select
                            hide-details
                            :items="bunks"
                            label="Bunk"
                            ref="chosenBunk"
                            v-model="student.chosenBunk"
                            :rules="[
                                (value) =>
                                    rules.required(
                                        value,
                                        student.enrollment.regType
                                    ),
                            ]"
                            box
                            item-text="`${data.item.grade} - ${data.item.teacher}`"
                        >
                            <template slot="selection" slot-scope="data">
                                {{ data.item.grade }} -
                                {{ data.item.teacher }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        v-html="
                                            `${data.item.grade} - ${
                                                data.item.teacher
                                            }`
                                        "
                                    >
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </v-select>
                    </v-flex>

                    <v-spacer> </v-spacer>
                    <v-layout row justify-end>
                        <div v-if="!editingAmount">
                            <v-layout row>
                                <v-card-title
                                    class="py-0"
                                    style="background-color: #FFF; border-style: solid; border-color: #5cb860;"
                                >
                                    <div class="font-weight-medium">
                                        ${{ getPaymentAmount(student) }}
                                    </div>
                                </v-card-title>
                                <v-card-actions class="py-0">
                                    <v-btn
                                        @click="edit"
                                        flat
                                        icon
                                        class="text-xs-right"
                                        color="success"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </div>
                        <div v-else>
                            <v-layout row>
                                <v-text-field
                                    class="mr-3 ml-3"
                                    label="Amount"
                                    placeholder="Amount"
                                    v-model="paymentAmount"
                                    @input="updateTotal(student)"
                                    prefix="$"
                                    type="number"
                                    hide-details
                                ></v-text-field>
                                <v-btn
                                    flat
                                    class="mr-1"
                                    @click="() => rollbackEditingAmount()"
                                    small
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    flat
                                    @click="editingAmount = false"
                                    small
                                    color="success"
                                >
                                    save
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout row justify-start>
                    <v-checkbox
                        style="max-width: 175px"
                        v-model="student.enrollment.lunchDoc"
                        class="ml-4"
                        label="Lunch Document"
                        color="success"
                    >
                    </v-checkbox>
                    <v-checkbox
                        style="max-width: 150px"
                        v-model="student.enrollment.covidTest"
                        class="ml-2"
                        label="Covid Test"
                        color="success"
                    >
                    </v-checkbox>
                    <v-checkbox
                        style="max-width: 150px"
                        v-model="student.enrollment.healthForm"
                        class="ml-2"
                        label="Health Form"
                        color="success"
                    >
                    </v-checkbox>
                    <v-checkbox
                        style="max-width: 150px"
                        v-model="student.enrollment.rulesForm"
                        class="ml-2"
                        label="Rules Form"
                        color="success"
                    >
                    </v-checkbox>
                </v-layout>
                <v-layout row justify-start>
                    <v-select
                        style="max-width: 175px"
                        class="mr-3 ml-4"
                        :items="insuranceCompanies.map((c) => c.value)"
                        label="Insurance Company"
                        v-model="student.enrollment.insuranceCompany"
                    ></v-select
                    ><v-text-field
                        style="max-width: 175px"
                        class="ml-2 mt-1 "
                        v-model="student.enrollment.insuranceID"
                        label="Insurance ID"
                    >
                    </v-text-field>
                </v-layout>
                <v-layout
                    row
                    wrap
                    class="pa-3 pb-2"
                    v-if="!student.isEnrolled || changeFromNone(student)"
                >
                    <v-flex
                        style="max-width: 200px;"
                        class="pl-0 pb-0 pr-2"
                        xs12
                        sm6
                        md2
                        v-for="charge in student.charges"
                    >
                        <v-text-field
                            @input="updateTotal(student)"
                            hide-details
                            prefix="$"
                            v-model="charge.paymentAmount"
                            :label="charge.name"
                            type="number"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    v-if="!student.isEnrolled || changeFromNone(student)"
                    row
                    justify-end
                    class="font-weight-medium headline text-success mt-0 pr-3 pb-3"
                >
                    <div class="pr-1">
                        Total:
                    </div>
                    <div class="">
                        {{ student.total | currency }}
                    </div>
                </v-layout>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" color="default" dark>
                    Close
                </v-btn>
                <v-btn
                    v-if="student.name"
                    color="success"
                    :loading="processing"
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { groupBy, onlyUnique, getDomain, sum } from "../../../utils/helpers.js";
import { loadOptions } from "../../../utils/smLookup.js";

export default {
    props: {
        student: Object,
        account: Object,
        girlsCampAccount: Object,
        refresh: Function,
        country: String,
        newStudentSelected: Function,
        newStudents: Array,
    },
    data() {
        return {
            dialogOpen: false,
            dates: [],
            rates: [],
            classes: [],
            bunks: [],
            editingAmount: false,
            paymentAmount: "",
            originalAmount: 0,
            processing: false,
            newStudent: {},
            insuranceCompanies: [],
            charges: [],

            gradesSetup: [],

            regID: "",

            rules: {
                required: (value, duration) => {
                    return duration == "NONE" || !!value || "Required.";
                },
            },
        };
    },
    async created() {
        await this.loadRegID();
        await this.loadRates();
        await this.loadDates();
        await this.loadInsuranceCompanies();
        await this.loadClasses();
        await this.loadGradesSetup();
        await this.loadCharges();
    },
    computed: {},
    watch: {
        newStudent(newValue, oldValue) {
            this.newStudentSelected(newValue);
        },
        student(newValue, oldValue) {
            this.paymentAmount = newValue.enrollment.amount;
        },
    },
    methods: {
        async loadRegID() {
            this.regID = "GC2020";
        },
        async loadInsuranceCompanies() {
            this.insuranceCompanies = await loadOptions("InsuranceCompany");
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isGirlsCampAvail;
        },
        async loadRates() {
            const rates = await this.$http.get(
                "api/lapidusDayCamp/getDayCampSetup"
            );

            this.rates = rates.filter((r) => r.udcregid == this.regID);
        },
        async loadCharges() {
            const charges = await this.$http.get("api/girlscamp/getcharges");

            this.charges = charges;
        },
        async loadDates() {
            const start = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "G" && f.udcregid == this.regID
                )[0].udcstarts
            ).toISOString();
            const end = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "G" && f.udcregid == this.regID
                )[0].udcends
            ).toISOString();

            const dates = await this.$http.get(
                `api/lapidusDayCamp/getHDates?startDate=${start}&endDate=${end}`
            );

            this.dates = this.setupDates(dates);
        },
        setupDates(dates) {
            return Object.keys(groupBy(dates, "hparsha")).map((week, index) => {
                const weekDays = groupBy(dates, "hparsha")[week];

                return {
                    parshe: week,
                    weekNumber: index,
                    dates: weekDays.map((d) => Date.parse(d.pardate)),
                    sunday: this.getDayOfWeek("Sunday", weekDays),
                    monday: this.getDayOfWeek("Monday", weekDays),
                    tuesday: this.getDayOfWeek("Tuesday", weekDays),
                    wednesday: this.getDayOfWeek("Wednesday", weekDays),
                    thursday: this.getDayOfWeek("Thursday", weekDays),
                    friday: this.getDayOfWeek("Friday", weekDays),
                    saturday: this.getDayOfWeek("Saturday", weekDays),
                };
            });
        },
        getDayOfWeek(day, weekDays) {
            return weekDays.find((w) => w.day == day);
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID
            );

            this.classes = classes.filter((c) => c.classType != "Bunk");
            this.bunks = classes.filter((c) => c.classType == "Bunk");
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup"
            );
        },
        changeFromNone(student) {
            return (
                student.originalDuration == "NONE" &&
                student.enrollment.regType != "NONE"
            );
        },
        getWeekProperty(index) {
            const weekNumber = 1 + index;

            return "week" + weekNumber;
        },
        getRate() {
            const rateCode = this.getRateCode();

            if (!rateCode) return 0;

            const rate = this.rates.find((r) => r.udcclass == rateCode);

            switch (this.student.enrollment.regType) {
                case "FULL":
                    return rate["udcamtf"];
                case "HALF 1":
                case "HALF 2":
                    return rate["udcamthalf"];
                case "CUSTOM":
                    const weekCount = Object.keys(this.student.enrollment)
                        .filter((key) => key.startsWith("week"))
                        .map((key) => this.student.enrollment[key])
                        .filter(Boolean).length;

                    return Math.min(
                        weekCount * rate["udcamt1w"],
                        rate["udcamtf"]
                    );
                default:
                    return 0;
            }
        },
        getRateCode() {
            return "G";
            // if (!this.country) return;

            // if (this.student.class == "B-06") {
            //     switch (this.country) {
            //         case "Satmar - Lapidus":
            //             return "LU-6";
            //         default:
            //             return "LO-6";
            //     }
            // }

            // if (!this.student.nonUTA) {
            //     switch (this.country) {
            //         case "Satmar - Lapidus":
            //             return "LU";
            //         default:
            //             if (
            //                 ["B-KNG", "B-NUR", "B-PRE1A"].includes(
            //                     this.student.class
            //                 )
            //             )
            //                 return "OU-YOUNG";

            //             return "OU-OLD";
            //     }
            // }

            // switch (this.country) {
            //     case "Satmar - Lapidus":
            //         return "LO";
            //     default:
            //         if (
            //             ["B-KNG", "B-NUR", "B-PRE1A"].includes(
            //                 this.student.class
            //             )
            //         )
            //             return "OO-YOUNG";

            //         return "OO-OLD";
            // }
        },
        // resetPrice() {
        //     this.paymentAmount = this.getRate();
        // },
        getPaymentAmount() {
            return this.paymentAmount || this.getRate();
        },

        updateTotal(student, durationUpdated = false) {
            //if (student.isEnrolled) return;

            if (
                student.enrollment.regType == "NONE" &&
                !this.changeFromNone(student)
            ) {
                student.total = 0;
                return;
            }

            student.paymentAmount = this.paymentAmount
                ? this.paymentAmount
                : this.getRate();

            if (durationUpdated) {
                this.paymentAmount = this.getRate();

                const laundry = student.charges.find(
                    (c) => c.name == "Laundry Fee"
                );

                const originalLaundry = this.charges.find(
                    (c) => c.name == "Laundry Fee"
                );

                if (laundry) {
                    laundry.paymentAmount = student.enrollment.regType.startsWith(
                        "HALF"
                    )
                        ? originalLaundry.amount / 2
                        : originalLaundry.amount;
                }
            }

            const charges = sum(student.charges.map((c) => +c.paymentAmount));

            student.total = +this.getPaymentAmount(student) + charges;
        },
        resetPrice() {
            const student = this.student;
            this.paymentAmount = this.getRate();

            student.charges.forEach((charge) => {
                const original = this.charges.find(
                    (c) => c.name == charge.name
                );

                charge.paymentAmount = original.amount;
            });

            this.updateTotal(student);
        },
        edit() {
            this.editingAmount = true;
            this.originalAmount = this.paymentAmount || this.getRate();
            this.paymentAmount = this.paymentAmount || this.getRate();
            this.updateTotal(this.student);
        },
        rollbackEditingAmount() {
            this.paymentAmount = "";
            this.editingAmount = false;
            this.originalAmount = 0;

            this.updateTotal(this.student);
        },
        rollback() {
            this.student.enrollment.regType = this.original.enrollment.regType;
            this.student.enrollment.week1 = this.original.enrollment.week1;
            this.student.enrollment.week2 = this.original.enrollment.week2;
            this.student.enrollment.week3 = this.original.enrollment.week3;
            this.student.enrollment.week4 = this.original.enrollment.week4;
            this.student.enrollment.week5 = this.original.enrollment.week5;
            this.student.enrollment.week6 = this.original.enrollment.week6;
            this.student.enrollment.week7 = this.original.enrollment.week7;
            this.student.enrollment.week8 = this.original.enrollment.week8;
            this.student.enrollment.week9 = this.original.enrollment.week9;
            this.student.enrollment.lunchDoc = this.original.enrollment.lunchDoc;
            this.student.enrollment.covidTest = this.original.enrollment.covidTest;
            this.student.enrollment.healthForm = this.original.enrollment.healthForm;
            this.student.enrollment.rulesForm = this.original.enrollment.rulesForm;

            this.student.chosenClass = this.original.chosenClass;
            this.student.chosenBunk = this.original.chosenBunk;
            this.paymentAmount = 0;
            this.editingAmount = false;
            this.newStudent = "";
        },
        openDialog(original) {
            this.original = original;

            this.dialogOpen = true;
        },
        cancel() {
            this.rollback();

            this.dialogOpen = false;
        },
        validate() {
            return (
                this.$refs.chosenClass.validate(true) &&
                this.$refs.chosenBunk.validate(true)
            );
        },
        async save() {
            if (!this.validate()) return;

            this.processing = true;

            const enrollment = this.student.enrollment;

            const data = {
                familyID: this.account.accountID,
                studentID: this.student.studentID,
                id: enrollment.id,
                regID: this.regID,
                regType: enrollment.regType,
                class: this.student.class,
                classId: this.student.chosenClass
                    ? this.student.chosenClass.classID
                    : "",
                bunkId: this.student.chosenBunk
                    ? this.student.chosenBunk.classID
                    : "",
                chargeCat: "GIRC",
                chargeCode: this.regID,
                amount: this.paymentAmount || this.getRate(),
                week1: this.hasWeek(enrollment, 1),
                week2: this.hasWeek(enrollment, 2),
                week3: this.hasWeek(enrollment, 3),
                week4: this.hasWeek(enrollment, 4),
                week5: this.hasWeek(enrollment, 5),
                week6: this.hasWeek(enrollment, 6),
                week7: this.hasWeek(enrollment, 7),
                week8: this.hasWeek(enrollment, 8),
                week9: this.hasWeek(enrollment, 9),
                lunchDoc: enrollment.lunchDoc,
                covidTest: enrollment.covidTest,
                rulesForm: enrollment.rulesForm,
                healthForm: enrollment.healthForm,
                insuranceID: enrollment.insuranceID,
                insuranceCompany: enrollment.insuranceCompany,
                price: this.getRate(),
            };

            try {
                await this.$http.post(
                    "api/girlsCamp/updateEnrollment?user=" +
                        this.$store.state.authentication.user,
                    data
                );

                if (
                    (!this.student.isEnrolled ||
                        this.changeFromNone(this.student)) &&
                    enrollment.duration != "NONE"
                ) {
                    return this.saveCharges();
                }
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;
            this.dialogOpen = false;

            this.refresh();
        },
        async saveCharges() {
            const charges = this.student.charges.map((charge) => {
                return {
                    studentID: this.student.studentID,
                    chargeName: charge.name,
                    amount: charge.paymentAmount ? charge.paymentAmount : 0,
                };
            });

            try {
                await this.$http.post(
                    "api/girlsCamp/saveCharges?user=" +
                        this.$store.state.authentication.user,
                    charges
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;
            this.dialogOpen = false;

            this.refresh();
        },
        hasWeek(enrollment, week) {
            switch (enrollment.regType) {
                case "FULL":
                    return true;
                case "CUSTOM":
                    const field = "week" + week;

                    return enrollment[field];
                case "HALF 1":
                    return week >= 1 && week <= 5;
                case "HALF 2":
                    return week >= 5 && week <= 9;
            }
        },
    },
};
</script>
